import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import CtaSection from "../components/CtaSection";
import { Reveal } from "../components/Reveal";
import { SERVICES, IMAGES } from "../data/site";
import { api } from "../lib/api";
import { useSiteImages } from "../lib/useSiteImages";

const CATEGORIES = ["すべて", ...SERVICES.map((s) => s.titleJa), "不動産開発"];

export default function Works() {
  const [cat, setCat] = useState("すべて");
  const siteImages = useSiteImages();
  const [works, setWorks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/works", { params: cat === "すべて" ? {} : { category: cat } })
      .then((r) => setWorks(r.data))
      .catch(() => setWorks([]))
      .finally(() => setLoading(false));
  }, [cat]);

  return (
    <div data-testid="works-page">
      <PageHero
        eyebrow="PROJECT ARCHIVE"
        titleEn="WORKS"
        titleJa="施工実績"
        desc="土木・環境整備・伐採・太陽光・開発。三重県を中心に積み重ねた実績の一部をご紹介します。"
        image={siteImages.works || IMAGES.civil}
      />
      <section className="border-t border-line py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-2">
            {CATEGORIES.map((c, i) => (
              <button
                key={c}
                data-testid={`works-filter-${i}`}
                onClick={() => setCat(c)}
                className={`border px-5 py-2.5 font-display text-xs font-bold tracking-[0.15em] transition-colors ${
                  cat === c ? "border-accent bg-accent text-ink" : "border-line text-gray-400 hover:border-accent hover:text-accent"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          {loading ? (
            <p data-testid="works-loading" className="mt-16 font-mono text-sm tracking-[0.3em] text-gray-500">
              LOADING...
            </p>
          ) : works.length === 0 ? (
            <p data-testid="works-empty" className="mt-16 text-sm text-gray-500">
              該当する実績はまだありません。
            </p>
          ) : (
            <div data-testid="works-grid" className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {works.map((w, i) => (
                <Reveal key={w.id} delay={(i % 3) * 0.08}>
                  <Link to={`/works/${w.id}`} data-testid={`work-card-${w.id}`} className="clip-corner group relative block overflow-hidden border border-line">
                    <img
                      src={w.image_url || IMAGES.civil}
                      alt={w.title}
                      loading="lazy"
                      className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
                    <div className="absolute left-4 top-4 bg-accent px-3 py-1 font-mono text-[10px] font-bold tracking-[0.2em] text-ink">{w.category}</div>
                    <div className="absolute bottom-0 w-full p-6">
                      <h3 className="font-mincho text-lg font-bold text-white">{w.title}</h3>
                      <p className="mt-2 text-xs leading-relaxed text-gray-400">{w.description}</p>
                      <p className="mt-3 font-mono text-[10px] tracking-[0.25em] text-gray-500">
                        {w.location} — {w.year}
                      </p>
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
          <p className="mt-12 font-mono text-[10px] tracking-[0.2em] text-gray-600">※ 掲載写真はイメージです。施工前後写真・詳細実績は順次公開予定です。</p>
        </div>
      </section>
      <CtaSection title="施工事例のような現場を、" highlight="次はあなたの土地で。" text="造成・整地・伐採・太陽光設備まで、まずは無料見積りから。" button="見積・工事の相談" to="/contact?type=estimate" />
    </div>
  );
}
